<template>
  <div>
    <header class="hero-page">
      <div class="bb-container">
        <div class="hero-page__container">
          <div class="hero-page__left">
            <h1 class="hero-page__title">{{ $t('landingDeals.hero.title', lang) }}</h1>
            <div class="hero-page__description">
              {{ $t('landingDeals.hero.description', lang) }}
            </div>
            <div class="hero-page__actions">
              <button class="button button--lg button--accent button--primary">
                {{ $t('landingDeals.hero.cta', lang) }}
              </button>
              <div class="hero-page__footnote">
                {{ $t('landingDeals.hero.footnote', lang) }}
              </div>
            </div>
          </div>
          <div class="hero-page__cover">
            <img src="../../assets/img/covers/promos_landing.webp" />
          </div>
        </div>
      </div>
    </header>

    <section class="tiendas-list tiendas-list--alt">
      <div class="tiendas-list__title">
        {{ $t('landingDeals.stores.title', lang) }}
      </div>
      <div class="tiendas-list__subtitle">
        {{ $t('landingDeals.stores.subtitle', lang) }}
      </div>

      <div class="tiendas-list__items">
        <VueSlickCarousel v-bind="shopSlider">
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-amazon.svg" alt="Amazon" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-ikea.svg" alt="IKEA" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-etsy.svg" alt="Etsy" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-sephora.svg" alt="Sephora" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-hm.svg" alt="H & M" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-maisons.svg" alt="Maisons du monde" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-zara.svg" alt="Zara" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-fr-kiavi.svg" alt="Kiavi" />
          </div>
        </VueSlickCarousel>
      </div>
    </section>
    
    <section class="promos-how-it-works">
      <div class="bb-container">
        <div class="promos-how-it-works__header">
          <div class="promos-how-it-works__title">
            {{ $t('landingDeals.howItWorks.title', lang) }}
          </div>
          <div class="promos-how-it-works__subtitle">
            {{ $t('landingDeals.howItWorks.subtitle', lang) }}
          </div>
        </div>

        <div class="promos-how-it-works__items">
          <div class="promos-how-it-works__item">
            <div class="promos-how-it-works__step">1</div>
            <div class="promos-how-it-works__item-title">
              {{ $t('landingDeals.howItWorks.step1.title', lang) }}
            </div>
            <div class="promos-how-it-works__item-text">
              {{ $t('landingDeals.howItWorks.step1.text', lang) }}
            </div>
          </div>

          <div class="promos-how-it-works__item">
            <div class="promos-how-it-works__step">2</div>
            <div class="promos-how-it-works__item-title">
              {{ $t('landingDeals.howItWorks.step2.title', lang) }}
            </div>
            <div class="promos-how-it-works__item-text">
              {{ $t('landingDeals.howItWorks.step2.text', lang) }}
            </div>
          </div>

          <div class="promos-how-it-works__item">
            <div class="promos-how-it-works__step">3</div>
            <div class="promos-how-it-works__item-title">
              {{ $t('landingDeals.howItWorks.step3.title', lang) }}
            </div>
            <div class="promos-how-it-works__item-text">
              {{ $t('landingDeals.howItWorks.step3.text', lang) }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="promos-last-message">
      <div class="bb-container">
        <div class="promos-last-message__box">
          <div class="promos-last-message__content">
            <div class="promos-last-message__title">
              {{ $t('landingDeals.final.title', lang) }}
            </div>

            <div class="promos-last-message__subtitle">
              {{ $t('landingDeals.final.subtitle', lang) }}
            </div>

            <div class="promos-last-message__text">
              {{ $t('landingDeals.final.text', lang) }}
            </div>

            <div class="promos-last-message__actions">
              <button class="button button--lg button--accent button--primary" ref="finalCTA">
                {{ $t('landingDeals.hero.cta', lang) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      class="floating-cta"
      :class="{ 'floating-cta--visible': showFloatingCTA }"
    >
      <button
        class="button button--accent button--primary floating-cta__button"
      >
        {{ $t('landingDeals.hero.cta', lang) }}
      </button>
    </div>

  </div>
</template>

<script>
import { buildSeoMetaInfo } from "../../seo/buildSeoMetaInfo.js";
import { HTML_LANG_MAP } from "../../seo/langMaps.js";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

const URL_ALTS = {
  "es": "https://www.hellobb.net/ofertas-descuentos",
  "en-GB": "https://www.hellobb.net/deals",
  "fr-FR": "https://www.hellobb.net/bons-plans",
  "de-DE": "https://www.hellobb.net/angebote",
  "it-IT": "https://www.hellobb.net/offerte",
  "pt-BR": "https://www.hellobb.net/ofertas",
  "nl-NL": "https://www.hellobb.net/aanbiedingen",
  "x-default": "https://www.hellobb.net/ofertas-descuentos",
}

export default {
  name: 'DealsPage',
  components: {
    VueSlickCarousel
  },

  metaInfo() {
    return buildSeoMetaInfo({
      vm: this,
      alts: URL_ALTS,
      appLang: this.lang,
      htmlLangMap: HTML_LANG_MAP,
      title: this.$t("landingDeals.meta.title", this.lang),
      description: this.$t("landingDeals.meta.description", this.lang),
    });
  },
  data() {
    return {
      shopSlider: {
        slidesToShow: 8,
        arrows: false,
        autoplay: true,
        dots: false,

        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px",
        edgeFriction: 0.35,
        speed: 500,
        responsive: [
          {
            breakpoint: 1000000,
            settings: {
              slidesToShow: 8,
              // variableWidth: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              // autoplay: false,
              slidesToShow: 2,
              variableWidth: true,
            },
          },
        ],
      },
      showFloatingCTA: false,
      finalCTAVisible: false,
    }
  },
  computed: {
    lang  () {
      return this.$route.meta?.lang || this.$i18n.locale;
    },
  },
  methods: {
    handleScroll() {
      const scroll = window.scrollY;

      if (scroll > 500 && !this.finalCTAVisible) {
        this.showFloatingCTA = true;
      } else {
        this.showFloatingCTA = false;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    const observer = new IntersectionObserver(
      ([entry]) => {
        this.finalCTAVisible = entry.isIntersecting;
      },
      { threshold: 0.3 }
    );

    observer.observe(this.$refs.finalCTA);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
</script>

<style scoped>
.hero-page {
  background:
    radial-gradient(circle at top left, rgba(255, 201, 68, 0.16), transparent 30%),
    radial-gradient(circle at bottom right, rgba(255, 201, 68, 0.1), transparent 28%),
    url(/bg-cercles-hero.svg) no-repeat 50%;
  background-size: cover;
  overflow: hidden;
}

.hero-page__container {
  padding: 5.5rem 0 5rem;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
  gap: 3.5rem;
  align-items: center;
}

.hero-page__left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.25rem;
  max-width: 560px;
}

.hero-page__title {
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 3rem;
  letter-spacing: -0.02em;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #1e0028;
  text-wrap: balance;
}

.hero-page__description {
  font-size: 1.1rem;
  line-height: 1.65;
  color: rgba(30, 0, 40, 0.78);
  max-width: 520px;
}

.hero-page__actions {
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.hero-page__footnote {
  margin-top: 1rem;
  font-size: 0.9rem;
  line-height: 1.5;
  color: rgba(30, 0, 40, 0.65);
  font-style: italic;
}

.hero-page__cover {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-page__cover::before {
  content: "";
  position: absolute;
  inset: auto auto 8% 8%;
  width: 88%;
  height: 88%;
  background: rgba(255, 201, 68, 0.16);
  filter: blur(40px);
  border-radius: 32px;
  z-index: 0;
}

.hero-page__cover img {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 760px;
  display: block;
  border-radius: 28px;
  object-fit: cover;
  box-shadow:
    0 24px 60px rgba(30, 0, 40, 0.14),
    0 8px 24px rgba(30, 0, 40, 0.08);
}

@media (max-width: 1199px) {
  .hero-page__container {
    gap: 2.5rem;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .hero-page__title {
    font-size: 2.5rem;
    letter-spacing: -0.02em;
    line-height: 1.1;
  }
}

@media (max-width: 991px) {
  .hero-page__container {
    padding: 3rem 0 2.5rem;
    display: flex;
    flex-direction: column-reverse;
    gap: 2rem;
  }

  .hero-page__left {
    max-width: none;
    gap: 1.25rem;
  }

  .hero-page__title {
    font-size: 2rem;
    max-width: none;
  }

  .hero-page__description {
    font-size: 1.1rem;
    line-height: 1.75;
    color: rgba(30, 0, 40, 0.72);
    margin-top: 0.25rem;
  }

  .hero-page__footnote {
    margin-top: 0.75rem;
    font-size: 0.9rem;
  }

  .hero-page__cover {
    width: 100%;
    max-height: none;
  }

  .hero-page__cover img {
    max-width: 100%;
    max-height: 360px;
  }
}

@media (max-width: 575px) {
  .hero-page__container {
    padding: 2.25rem 0 2rem;
    gap: 1.5rem;
  }

  .hero-page__title {
    font-size: 1.75rem;
    line-height: 1.15;
  }

  .hero-page__description {
    font-size: 1.15rem;
  }

  .hero-page__actions {
    width: 100%;
  }

  .hero-page__actions .button {
    width: 100%;
  }

  .hero-page__footnote {
    width: 100%;
  }

  .hero-page__cover img {
    border-radius: 20px;
    max-height: 240px;
  }
}

.promos-how-it-works {
  padding: 4.5rem 0 5rem;
  background: rgba(205, 239, 242, .4);
}

.promos-how-it-works__header {
  max-width: 760px;
  margin: 0 auto 2.5rem;
  text-align: center;
}

.promos-how-it-works__title {
  margin: 0;
  font-size: 2.2rem;
  line-height: 1.15;
  font-weight: 700;
  color: #1e0028;
}

.promos-how-it-works__subtitle {
  margin-top: 1rem;
  font-size: 1.05rem;
  line-height: 1.7;
  color: rgba(30, 0, 40, 0.72);
}

.promos-how-it-works__items {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.5rem;
}

.promos-how-it-works__item {
  padding: 1.75rem;
  background: #fff;
  border: 1px solid rgba(30, 0, 40, 0.08);
  border-radius: 24px;
  box-shadow: 0 16px 40px rgba(30, 0, 40, 0.06);
}

.promos-how-it-works__step {
  width: 44px;
  height: 44px;
  margin-bottom: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #ffc944;
  color: #1e0028;
  font-size: 1.1rem;
  font-weight: 700;
}

.promos-how-it-works__item-title {
  margin-bottom: 0.75rem;
  font-size: 1.15rem;
  line-height: 1.3;
  font-weight: 700;
  color: #1e0028;
}

.promos-how-it-works__item-text {
  font-size: 1rem;
  line-height: 1.7;
  color: rgba(30, 0, 40, 0.75);
}

@media (max-width: 991px) {
  .promos-how-it-works {
    padding: 3.25rem 0 3.5rem;
  }

  .promos-how-it-works__title {
    font-size: 1.8rem;
  }

  .promos-how-it-works__items {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 575px) {
  .promos-how-it-works__header {
    margin-bottom: 2rem;
  }

  .promos-how-it-works__title {
    font-size: 1.6rem;
  }

  .promos-how-it-works__subtitle {
    font-size: 0.98rem;
  }

  .promos-how-it-works__item {
    padding: 1.25rem;
    border-radius: 20px;
  }
}

.promos-last-message {
  padding: 4rem 0 5rem;
}
.promos-last-message__box {
  background: #ffc944;
  border-radius: 32px;
  padding: 3.5rem 2rem;
  box-shadow: 0 20px 50px rgba(30, 0, 40, 0.08);
}

.promos-last-message__content {
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
}

.promos-last-message__title {
  margin: 0;
  font-size: 2.4rem;
  line-height: 1.12;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1e0028;
}

.promos-last-message__subtitle {
  margin-top: 1.25rem;
  font-size: 1.08rem;
  line-height: 1.75;
  color: rgba(30, 0, 40, 0.75);
}

.promos-last-message__text {
  margin-top: 1.5rem;
  font-size: 1.1rem;
  line-height: 1.65;
  font-weight: 600;
  color: #1e0028;
}

.promos-last-message__actions {
  margin-top: 2rem;
}

@media (max-width: 991px) {
  .promos-last-message {
    padding: 3.5rem 0 4rem;
  }

  .promos-last-message__box {
    border-radius: 28px;
    padding: 3rem 1.5rem;
  }

  .promos-last-message__title {
    font-size: 1.95rem;
  }

  .promos-last-message__subtitle {
    font-size: 1rem;
    line-height: 1.7;
  }

  .promos-last-message__text {
    font-size: 1.02rem;
  }
}

@media (max-width: 575px) {
  .promos-last-message {
    padding: 3rem 0 3.5rem;
  }

  .promos-last-message__box {
    border-radius: 22px;
    padding: 2.25rem 1.25rem;
  }

  .promos-last-message__title {
    font-size: 1.7rem;
    line-height: 1.18;
  }

  .promos-last-message__subtitle {
    margin-top: 1rem;
    font-size: 0.98rem;
  }

  .promos-last-message__text {
    margin-top: 1.25rem;
    font-size: 1rem;
  }

  .promos-last-message__actions {
    margin-top: 1.5rem;
  }

  .promos-last-message__actions .button {
    width: 100%;
  }
}

.floating-cta {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 50;

  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;

  transition: all 0.25s ease;
}

.floating-cta--visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.floating-cta__button {
  box-shadow: 0 12px 28px rgba(30, 0, 40, 0.18);
}

@media (max-width: 575px) {

  .floating-cta {
    left: 16px;
    right: 16px;
    bottom: 16px;
  }

  .floating-cta__button {
    width: 100%;
  }

}

</style>
